module.exports = __webpack_public_path__ + "static/media/time_86400.45d3021a.png";